import {usePhpJs} from '../../utils/php-js';

export const useDoesPracticeHaveAccess = (feature: string): boolean => {
  return usePhpJs((phpJs = {}) =>
    (phpJs.practiceFeatures || []).includes(feature)
  );
};
